module.exports = __webpack_public_path__ + "img/Bellavista.cd1fd5ee.svg";